import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

import * as c from "./featurePageHeader.module.scss";
import { processMarkdown } from "@utils/markdown";
import StaticGradient from "@components/shared/staticGradient";
import WaveBackground from "@components/shared/waveBackground";

export const FeaturePageHeader = ({ pageHeaderData = {} }) => {
  const { label, heading, subheading, desktopImage, mobileImage } = pageHeaderData;

  const subheadingText = subheading?.subheading;
  return (
    <div className={c.background}>
      <StaticGradient
        opacity="0.45"
        top="-100px"
        mask="linear-gradient(to bottom, #000 0%, transparent 100%)"
        height="50%"
      />

      <section className={c.container}>
        <div className={c.featurePageContent}>
          <h1 className={classNames(c.headline, "h1")} dangerouslySetInnerHTML={{ __html: heading }} />
          {subheadingText && (
            <p
              className={classNames(c.subheading, "p2")}
              dangerouslySetInnerHTML={{ __html: processMarkdown(subheadingText) }}
            />
          )}
        </div>

        {(desktopImage || mobileImage) && (
          <div className={c.featurePageImageContainer}>
            {desktopImage && (
              <GatsbyImage
                image={getImage(desktopImage)}
                className={c.desktopImage}
                loading="eager"
                alt={label ? `${label} - Desktop image` : "Desktop image"}
              />
            )}
            {mobileImage && (
              <GatsbyImage
                image={getImage(mobileImage)}
                className={c.mobileImage}
                loading="eager"
                alt={label ? `${label} - Mobile image` : "Mobile image"}
              />
            )}
          </div>
        )}
        <WaveBackground />
      </section>
    </div>
  );
};
